module.exports = __webpack_public_path__ + "static/media/card-img-default.442059fa.jpg";